exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--1mgA7dhoUerHsby2g1MBg_.care-team-tasks--2hRSnP4dhvJLSD3239N2zi {\n  box-sizing: border-box;\n  background: #fff;\n  border: 1px solid #dadada;\n  border-radius: 5px;\n}\n", ""]);

// exports
exports.locals = {
	"formFieldContainer": "care-team-tasks--1mgA7dhoUerHsby2g1MBg_",
	"formFieldContainer": "care-team-tasks--1mgA7dhoUerHsby2g1MBg_",
	"checklistFormContainer": "care-team-tasks--2hRSnP4dhvJLSD3239N2zi",
	"checklistFormContainer": "care-team-tasks--2hRSnP4dhvJLSD3239N2zi"
};